import React, { useEffect } from "react";
import PropTypes from "prop-types";

const Pagination = ({
  size,
  itemsPerPage,
  totalItems,
  currentPage,
  onPageChange,
}) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  useEffect(() => {
    if (currentPage > totalPages && totalPages > 0) {
      onPageChange(totalPages);
    }
    if (currentPage < 1) {
      onPageChange(1);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, totalItems, itemsPerPage]);

  const handlePrevPage = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages || !totalItems) {
      onPageChange(currentPage + 1);
    }
  };

  const handleFirstPage = () => {
    onPageChange(1);
  };

  const handleLastPage = () => {
    onPageChange(totalPages);
  };

  const renderPageNumbers = () => {
    if (!totalItems) {
      return (
        <li key={currentPage}>
          <button className={`btn btn-sm ms-2 btn-primary`}>
            {currentPage || 1}
          </button>
        </li>
      );
    }
    let startPage = Math.max(1, currentPage - 2);
    let endPage = Math.min(totalPages, currentPage + 2);

    if (endPage - startPage < 4) {
      if (startPage === 1) {
        endPage = Math.min(totalPages, startPage + 4);
      } else if (endPage === totalPages) {
        startPage = Math.max(1, endPage - 4);
      }
    }

    const pageNumbers = [];
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    return pageNumbers.map((page) => (
      <li key={page}>
        <button
          className={`btn btn-sm ms-2 ${
            currentPage === page ? "btn-primary" : "btn-light border"
          }`}
          onClick={() => onPageChange(page)}
        >
          {page}
        </button>
      </li>
    ));
  };

  return (
    <nav>
      <ul className="pagination d-flex mb-0 align-items-center overflow-hidden">
        <li>
          <button
            className="btn btn-sm btn-light border me-2"
            onClick={handleFirstPage}
            disabled={currentPage === 1}
          >
            <i className="fa fa-angle-double-left" />
          </button>
        </li>
        <li>
          <button
            className="btn btn-sm btn-light border"
            onClick={handlePrevPage}
            disabled={currentPage === 1}
          >
            <i className="fa fa-chevron-left" />
          </button>
        </li>
        {size !== "sm" ? (
          renderPageNumbers()
        ) : (
          <li key={currentPage}>
            <button className="btn ms-2 btn-primary">{currentPage}</button>
          </li>
        )}
        <li>
          <button
            className="btn btn-sm btn-light border ms-2"
            onClick={handleNextPage}
            disabled={totalItems ? currentPage === totalPages : false}
          >
            <i className="fa fa-chevron-right" />
          </button>
        </li>
        {totalItems && (
          <li>
            <button
              className="btn btn-sm btn-light border ms-2"
              onClick={handleLastPage}
              disabled={totalItems ? currentPage === totalPages : false}
            >
              <i className="fa fa-angle-double-right" />
            </button>
          </li>
        )}
      </ul>
    </nav>
  );
};

Pagination.propTypes = {
  itemsPerPage: PropTypes.number.isRequired,
  totalItems: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
};

export default Pagination;
